/* eslint-disable import/prefer-default-export */
import getQuery from '../../utilities/query';
import { staking } from '../../api';
import { handleError } from '../../utilities/errorHandling';

const queryClient = getQuery();

export const GET_ALL_STAKINGS = 'staking.all';

export const GET_STAKING_DETAILS = 'staking.details';

export const GET_STAKING_TIERS = 'staking.tiers';

export const GET_ACTIVE_STAKING_AMOUNT_WITH_TIERS = 'active.staking.tiers';

queryClient.setQueryDefaults(GET_ALL_STAKINGS, {
  queryFn: () => staking.all(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(GET_STAKING_DETAILS, {
  queryFn: async ({ queryKey }) => {
    const { data } = await staking.details(queryKey[1]);
    return data;
  },
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(GET_STAKING_TIERS, {
  queryFn: () => staking.stakingTiers(),
  onError: (error) => {
    handleError(error);
  },
});

queryClient.setQueryDefaults(GET_ACTIVE_STAKING_AMOUNT_WITH_TIERS, {
  queryFn: () => staking.activeStakingAmountWithTier(),
  onError: (error) => {
    handleError(error);
  },
});
